export default __webpack_public_path__ + "static/media/gestion-agricola.416a9a1a.webp";